<div class="border-0 px-4 py-1 scroll-container" ref="manage_questions">
  <NavigationBackButton/>
    <div class="card-header  card-header-primary shadow rounded-lg mt-2">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li class="rounded-lg me-2 nav-item">
              <a class="text-white text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
                <span><i class="bi bi-file-text fs-4 me-2"></i> </span>Documents Workflow
              </a>
            </li>
          </ul>
          <div class="d-flex flex-row justify-content-end">
            <button class="btn btn-primary-dark btn-sm text-xxs shadow ms-3 mb-1"
            data-bs-toggle="modal"
            data-bs-target="#create_signing_workflow"
            @click="prepare_create_workflow"> Create Workflow</button>
        </div>
        </div>
      </div>
    </div>
    <div class="glassy-table rounded-lg border-0 shadow mt-2">


        <div class="card-body">
            <GlobalTable
                :headers="['ID','Workflow name', 'Workflow description']"
                :data="signing_workflows"
                :table_id="signing_workflows_table">
                <template #actions="{ row }">
                  <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#view_signing_workflow" @click="get_workflow(row.id)">View</button>
                  <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"  data-bs-toggle="modal" data-bs-target="#assign_workflow_to_template" @click="get_selected_workflow_id(row)">Assign</button>
                  <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal" data-bs-target="#update_signing_workflow" @click="prepare_update_workflow(row)">Edit</button>
                </template>
            </GlobalTable>
         </div>
    </div>
</div>

<!--Create workflow modal-->
<teleport to="body">
<div class="modal fade" id="create_signing_workflow" tabindex="-1" aria-labelledby="create_signing_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs" id="create_signing_workflow_label">Create Workflow</p>
              <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3 d-flex flex-column">
                <label for="workflow_name" class="modal-form-label form-label text-start text-xxs">Workflow Name:</label>
                <input type="text" id="workflow_name" v-model="workflow_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Please enter a name for the workflow" aria-labelledby="workflow_name">
                <small id="workflow_name_error" class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a name for the workflow</small>
                <small id="workflow_name_generic_error" class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
            </div>

            <div class="modal-form-group form-group mb-3 d-flex flex-column">
                <label for="workflow_description" class="modal-form-label form-label text-start text-xxs">Workflow Description:</label>
                <input type="text" id="workflow_description" v-model="workflow_description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Please enter a description for the workflow" aria-labelledby="workflow_description">
                <small id="workflow_description_error" class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description for the workflow</small>
                <small id="workflow_description_generic_error" class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
            </div>

            <div v-if="selected_entity_types.length > 0" class="lead-status-timeline mt-5">
              <div class="timeline-viewport">
                <div class="status-progress">
                  <div v-for="(step, index) in selected_entity_types" :key="index" class="status-step">
                    <div class="circle">{{ index + 1 }}</div>
                    <div class="label">{{ step.entity_type_name }}</div>
                    <div v-if="index < selected_entity_types.length - 1" class="connector"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-4 mt-5">
              <p class="fw-bold text-xs">Select Entity Type for Workflow:</p>
              <div class="d-flex flex-column gap-2 timeline-scrollable">
                <div v-for="type in entity_types" :key="type.id" class="card p-2 border border-light rounded shadow-sm d-flex flex-row align-items-center">
                  <input class="form-check-input me-2" type="checkbox" :id="'type-' + type.id" :value="type" v-model="selected_entity_types"/>
                  <label class="form-check-label text-xxs mb-0" :for="'type-' + type.id">{{ type.entity_type_name }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow-sm" @click="create_signing_workflow">Save</button>
          </div>
      </div>
  </div>
</div>
</teleport>

<!-- View created workflow -->
 <teleport to="body">
<div class="modal fade" id="view_signing_workflow" tabindex="-1" aria-labelledby="view_signing_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="view_signing_workflow_label">View Workflow</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="lead-status-timeline mt-3">
          <div class="timeline-viewport">
            <div class="status-progress">
              <div v-for="(step, step_index) in view_workflow.entity_types" :key="step_index" class="status-step">
                <div class="circle">{{ step_index + 1 }}</div>
                <div class="label">{{ step.entity_type_name }}</div>
              <div v-if="step_index < view_workflow.entity_types.length - 1" class="line"></div>
          </div>
          </div>

          </div>
        </div>

        <div class="mb-3 mt-3">
          <label class="form-label text-start text-xxs fw-bold">Workflow Name:</label>
          <p class="text-xxs mb-0">{{ view_workflow.name }}</p>
        </div>

        <div class="mb-3">
          <label class="form-label text-start text-xxs fw-bold">Workflow Description:</label>
          <p class="text-xxs mb-0">{{ view_workflow.description }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<!--Update workflow modal-->
<teleport to="body">
<div class="modal fade" id="update_signing_workflow" tabindex="-1" aria-labelledby="update_signing_workflow_label" aria-hidden="true">
  <div class="modal-dialog modal-xl">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
              <p class="modal-title text-white text-xxs" id="update_signing_workflow_label">Update Workflow</p>
              <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-form-group form-group mb-3 d-flex flex-column">
                <label for="update_workflow_name" class="modal-form-label form-label text-start text-xxs">Workflow Name:</label>
                <input type="text" id="update_workflow_name" v-model="update_workflow_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Please enter a name for the workflow" aria-labelledby="workflow_name">
            </div>

            <div class="modal-form-group form-group mb-3 d-flex flex-column">
                <label for="update_workflow_description" class="modal-form-label form-label text-start text-xxs">Workflow Description:</label>
                <input type="text" id="update_workflow_description" v-model="update_workflow_description" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" placeholder="Please enter a description for the workflow" aria-labelledby="workflow_description">
            </div>

            <div v-if="selected_entity_types.length > 0" class="lead-status-timeline mt-5">
              <div class="timeline-viewport">
                <div class="status-progress">
                  <div v-for="(step, index) in selected_entity_types" :key="index" class="status-step">
                    <div class="circle">{{ index + 1 }}</div>
                    <div class="label">{{ step.entity_type_name }}</div>
                    <div v-if="index < selected_entity_types.length - 1" class="line"></div>
                  </div>
                </div>
            </div>


            </div>

            <div class="mb-4 mt-5">
              <p class="fw-bold text-xs">Select Entity Type for Workflow:</p>
              <div class="d-flex flex-column gap-2 timeline-scrollable">
                <div v-for="type in entity_types" :key="type.id" class="card p-2 border border-light rounded shadow-sm d-flex flex-row align-items-center">
                  <input class="form-check-input me-2" type="checkbox" :id="'type-' + type.id" :value="type" v-model="selected_entity_types"/>
                  <label class="form-check-label text-xxs mb-0" :for="'type-' + type.id">{{ type.entity_type_name }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
              <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow-sm" @click="update_signing_workflow">Save</button>
          </div>
      </div>
  </div>
</div>
</teleport>

<!-- Assign Workflow modal -->
 <teleport to="body">
<div class="modal fade" id="assign_workflow_to_template" tabindex="-1" aria-labelledby="assign_workflow_to_template_label" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content bg-white rounded-3">
        <div class="modal-header border-bottom-0 custom-header text-white">
          <h5 class="modal-title text-xxs" id="assign_workflow_to_template_label">Assign Workflow</h5>
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body py-5">
        <table id="assign_template_table" class="table-responsive w-100 table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">ID</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Template Name</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Assign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(template, index) in templates" :key="template.id">
              <td class="text-xxs text-start">{{ index + 1 }}</td>
              <td class="text-xxs text-start">{{ template.name }}</td>
              <td class="text-xxs text-start">
                <div class="form-check form-switch d-flex">
                 <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="is_workflow_assigned(template.id)"
                    @change="toggle_workflow_assignment(template.id)"
                  />

                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
</div>
</teleport>